import gql from 'graphql-tag';
import { PLANOGRAM_ITEM_PLANOGRAM_DETAIL_FRAGMENT } from './PLANOGRAM_ITEM_PLANOGRAM_DETAIL_FRAGMENT';

const QUEUE_PLANOGRAM_ITEM_PRODUCT_CHANGES = gql`
	mutation queuePlanogramItemProductChanges (
		$changes: [PlanogramItemProductChangeInput!]!,
	) {
		queuePlanogramItemProductChanges(
			changes: $changes,
		) {
			...planogramItemPlanogramDetail
		}
	}
	${PLANOGRAM_ITEM_PLANOGRAM_DETAIL_FRAGMENT}
`;

export default QUEUE_PLANOGRAM_ITEM_PRODUCT_CHANGES;
